let initialState = {
  dataSearch: {},
  goBack: false
}

function baoCaoTongHop(state = initialState, action) {
  let newState = {
    ...state
  };
  switch (action.type) {
    case 'BCTH_UPDATE_DATA_SEARCH':
      newState.dataSearch = action.dataSearch;
      return newState;
    case 'BCTH_GO_BACK':
      newState.goBack = true;
      return newState;
    case 'BCTH_RESET_GO_BACK':
      newState.goBack = false;
      return newState;
    default:
      return newState;
  }
}

export { baoCaoTongHop }



// WEBPACK FOOTER //
// ./src/reducers/baoCaoTongHop.js